import { render, staticRenderFns } from "./PlayVideoPopup.vue?vue&type=template&id=6330c845&scoped=true&"
import script from "./PlayVideoPopup.vue?vue&type=script&lang=ts&"
export * from "./PlayVideoPopup.vue?vue&type=script&lang=ts&"
import style0 from "./PlayVideoPopup.vue?vue&type=style&index=0&id=6330c845&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6330c845",
  null
  
)

export default component.exports